import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.625 8.2168L20.625 10.2168V20.2168C20.625 21.3214 19.7296 22.2168 18.625 22.2168H6.625C5.52043 22.2168 4.625 21.3214 4.625 20.2168V10.2168L3.625 8.2168H21.625ZM16.625 11.2168H14.625V19.2168H16.625V11.2168ZM10.625 11.2168H8.625V19.2168H10.625V11.2168ZM2.625 7.2168V5.2168H7.625V4.2168C7.625 3.11223 8.52043 2.2168 9.625 2.2168H15.625C16.7296 2.2168 17.625 3.11223 17.625 4.2168V5.2168H22.625V7.2168H2.625Z",
		fill: "#395566"
	})
});
export default SvgFill;
